import Card from './Card'
import { Label } from './Field'
import { Picpay } from '~/icons'

export default function ContentPicpay() {
  return (
    <Card color="secondary">
      <Picpay className="fill-primary-success text-xl" />
      <h2 className="font-medium">Pague com PicPay, direto do seu celular.</h2>
      <Label>
        Ao finalizar a compra, um código será exibido. Para pagar, basta escanear o código com seu PicPay.
      </Label>
      <Label>Ainda não tem conta? Baixe o app gratuitamente no Android ou iPhone.</Label>
    </Card>
  )
}
